// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3PjZt","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__FpO5w"};